<template>
  <div class="c-button--options-pad">
    <button v-for="option of options" v-on:click.prevent="valuePressed(option.value)"
            :key="option.value" class="c-button c-button--square c-button-option c-button--primary"
            :class="{'numpad-long': valueType.longLabels}">
      {{getLabel(option.label)}}
    </button>
  </div>
</template>

<script>
  export default {
    name: "select-options",
    props: ["valueType"],
    computed: {
      options: function() {
        return this.valueType.options;
      },
		},
    methods: {
      valuePressed: function(value) {
        this.$emit('value', {value: value});
        this.actionPressed('next');
      },
      actionPressed: function(action) {
        this.$emit('action', {action: action});
      },
      getLabel(label) {

        const key = 'valueOption.' + label
        const val = this.$t(key)

        if (val === key) {
          return label
        }
        return val
      },
    }
  };
</script>

<style scoped>
  .numpad-long {
    width: 100%;
  }
</style>
